import 'css-chunksrc/client/scenes/task/details/expenditureTypeSelector/styles.scss';export default {
  "row": "_row_1dtj9_1",
  "label": "_label_1dtj9_5",
  "root": "_root_1dtj9_12",
  "input": "_input_1dtj9_17",
  "icon": "_icon_1dtj9_39",
  "listRoot": "_listRoot_1dtj9_47",
  "list": "_list_1dtj9_47",
  "option": "_option_1dtj9_63",
  "selected": "_selected_1dtj9_79",
  "opened": "_opened_1dtj9_92"
};